export { parseTemplate, validateTags, isTag, hasTag } from './parse-template';
